module.exports = __webpack_public_path__ + "img/straight-quotes.45b1d786.svg";